export function initializeAngularBroadcastEventListener(
  rootScope,
  event,
  func
) {
  return rootScope.$on(event, func)
}
